<template>
    <div class="info-list">
        <Header/>
        <div class="blank20"/>
        <div class="rdg_biv_t">财务数据分析师全国统一报名入口</div>
        <div class="user_reg">
            <div class="r_tit">资格审核</div>
            <div class="blank20"/>
            <div class="l-r-content" :style="{height:contentHeigth}">
                <div class="mes">
                    <img :src="Number(userInfo.is_checked)===0?require('../assets/unchecked.png'):require('../assets/checked.png')"><br>
                    <!-- {{Number(userInfo.is_checked)===0?'待审核':'审核通过'}} -->
                </div>
            </div>
        </div>
        <div class="blank20"/>
        <Footer/>
    </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
    data() {
        return {
            temToken:'',
            contentHeigth:0,
        }
    },
    computed:mapState([
        'userInfo'
    ]),
    components:{
    },
    mounted() {
        console.log(document.body.clientHeight);
        this.contentHeigth = document.body.clientHeight - 400 + 'px';
    },
    methods: {
        
    },
}
</script>
<style lang="scss" scoped>
@import '../assets/user.scss';
.mes{
    width: 50px;
    margin: auto;
    text-align: center;
    img{
        width: 108px;
    }
}
</style>
